'use client';

import React from 'react';
import { FileText } from 'lucide-react';
import LegalDocumentBody from '@/components/LegalDocumentBody';

export default function TermsOfServiceContent() {
  return (
    <LegalDocumentBody
      pageId="terms"
      icon={<FileText size={13} className="text-primary" />}
      footerLinks={[
        { href: '/privacy-policy', labelKey: 'privacyLink' },
        { href: '/about', labelKey: 'aboutLink' },
      ]}
    />
  );
}
